import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type {TextBackgroundObject} from '@PosterWhiteboard/items/text-item/text-background';

export function useGetKeyFromBackgroundOfTextActiveItem<T extends keyof TextBackgroundObject>(key: T): TextBackgroundObject[T] | undefined {
  const activeItemId = useSingleActivePosterItemId() ?? '';

  return useAppSelector((state) => {
    const item = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap[activeItemId];

    if (item && 'background' in item && item.background[key] !== undefined) {
      return item.background[key];
    }

    return undefined;
  });
}
